import { usersApiFactory } from "./AcRedSelFactory";

export const newUsers = usersApiFactory('USERS', 'https://jsonplaceholder.typicode.com/users');
